export const BASE_URL =
  window.location.hostname === 'localhost'
    ? 'http://localhost:8080'
    : 'https://eliasmeanawebsite.onrender.com';
